<template>
  <div>
    <load-content :loading="!isReady">
      <router-view v-if="isReady" />
    </load-content>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import LoadContent from '../components/load-content';

export default {
  mounted() {
    if (this.$store.state.isInsight) {
      this.isReady = true;
      return;
    }
    this.getUserInfo().then(this.getPermissions).then(() => {
      if (this.isRouteAllowed() !== true) {
        this.$router.replace('/');
      }
      this.isReady = true;
    });
  },

  components: {
    LoadContent
  },

  data: function() {
    return {
      isReady: false
    }
  },

  computed: {
    ...mapState({
      user: state => state.user.user.data,
      isBusy: state => state.user.user.isBusy
    }),
    ...mapGetters({
      hasAclPermission: 'acl/hasAclPermission'
    })
  },

  watch: {
    $route() {
      if (this.$store.state.isInsight === true) {
        return;
      }
      if (this.isReady === true && this.isRouteAllowed() !== true) {
        this.$router.replace('/');
      }
    }
  },

  methods: {
    ...mapActions({
      getUserInfo: 'user/getUserInfo',
      getPermissions: 'acl/getPermissions'
    }),

    isRouteAllowed() {
      const allRoles = [];
      this.$route.matched.forEach((record) => {
        const props = record.props && record.props.default;
        if (props && Array.isArray(props.roles) && _.isEmpty(props.roles) === false) {
          allRoles.push(...props.roles);
        }
      });

      if (allRoles.indexOf('code_admin') !== -1 && this.user.code_admin !== true) {
        return false;
      }

      const bodhiRoles = allRoles.filter((role) => role !== 'code_admin');
      if (bodhiRoles.length > 0) {
        const roleMap = this.user.role || {};
        const hasRole = bodhiRoles.some((role) => roleMap[role] === true);
        if (hasRole !== true) {
          return false;
        }
      }

      const permissions = this.$route.meta.permissions;
      if (this.user.code_admin !== true && permissions !== undefined) {
        if (this.user.permissions[permissions.name] !== permissions.level) {
          return false;
        }
      }

      if (this.checkAclGuard(this.$route) !== true) {
        return false;
      }

      return true;
    },

    checkAclGuard(route) {
      const denied = route.matched.some((record) => {
        const acl = record.meta && record.meta.acl;
        if (!acl) {
          return false;
        }
        if (Array.isArray(acl)) {
          if (acl.length === 0) {
            return false;
          }
          return acl.every((rule) => this.hasAclPermission(rule.group, rule.action) === true) !== true;
        }
        const actions = Array.isArray(acl.actions) ? acl.actions : (acl.action ? [acl.action] : []);
        if (actions.length === 0) {
          return false;
        }
        return actions.some((action) => this.hasAclPermission(acl.group, action) === true) !== true;
      });
      return denied !== true;
    }
  },
}
</script>
